module.exports = __webpack_public_path__ + "static/lessor-datasheet.77854c97.pdf";


//////////////////
// WEBPACK FOOTER
// ./assets/forms/lessor-datasheet.pdf
// module id = 308
// module chunks = 114276838955818